<main>
<div class="container">

    <div class="row my-5">
        <div class="col-4 mx-auto">
            <div tabindex="0" class="e-card" id="basic">
                <img src="assets/images/company_logo_transparent.png" class="rounded mx-auto d-block mb-3 Logo">
                <div class="e-card-header text-center">
                    <div class="e-card-header-caption">
                        <div class="e-card-title">
                            <h4 class="heading">Reset Password</h4>
                        </div>
                    </div>
                </div>
                <div class="e-card-content">
                    <div class="wrap">
                        <div class="e-float-input e-input-group e-success" id="newPassword">
                            <input type="password" id="txtNewPassword" required />
                            <span class="e-float-line"></span>
                            <label class="e-float-text">New Password</label>
                        </div>
                        <div class="e-float-input e-input-group e-success" id="confirmNewPassword">
                            <input type="password" id="pwd" required />
                            <span class="e-float-line"></span>
                            <label class="e-float-text">Confirm Password</label>
                        </div>
                        <div class="resetPwd-captcha mt-3">
                            <div class="e-float-input e-input-group captchaCol e-success">
                                <input type="text" id="txtCompare3" required />
                                <span class="e-float-line"></span>
                                <label class="e-float-text">Enter Captcha</label>
                            </div>
                            <div class="card mt-2 captchaCol" style="height: 2.5em;">
                                <input type="" class="blur noselect" id="txtCaptcha3" onmousedown="return false;"
                                    onselectstart='return false;' />
                            </div>
                        </div>

                    </div>

                </div>
                <div class="row mx-auto mb-3">
                    <button type="button" class="btn btn-success" onclick="ValidCaptcha3();">Save</button>
                </div>

                <div class="link mx-auto text-center">
                    <a [routerLink]="['/log-in']" href="#">Back to Log in</a>
                </div>
            </div>
        </div>
    </div>


</div>
</main>
<footer id="footerContent4">
    <img src="assets/images/company_logo_transparent.png" class="rounded mx-auto d-block mb-3 toolbarLogo">
    <p>Powered by PubMate. IN. An iCodex Product.<br> All rights reserved by iCodex 2021</p>
</footer>
